<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'companyName'">
          <feather-icon icon="BriefcaseIcon" class="mr-50" />ผู้ประกอบการ /
          <feather-icon icon="UserIcon" class="mr-50" />ชื่อผู้ร้องทุกข์ /
          <feather-icon icon="UsersIcon" class="mr-50" /> ผู้มอบอำนาจ
        </span>
        <span v-else-if="props.column.field == 'action'">
          <feather-icon icon="PaperclipIcon" />
          <small> แนบเอกสารเพิ่มเติม </small>
          <br />
          <feather-icon icon="EyeIcon" />
          <small> แบบฟอร์ม/รายการเอกสารเนบ </small>
        </span>
        <span v-else>
          {{ props.column.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.sarabunCode }}</span>
          <!-- <br
            v-if="
              props.row.sarabunCode !== null &&
                props.row.sarabunCode !== undefined &&
                props.row.sarabunCode !== ''
            "
          />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.sarabunCode }}</span
          >
          <br
            v-if="
              props.row.provinceName !== null &&
                props.row.provinceName !== undefined &&
                props.row.provinceName !== ''
            "
          />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.provinceName }}</span
          > -->
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <!-- <span
            v-for="(item, index) in props.row.companyNameList"
            class="text-nowarp"
            v-b-tooltip.hover
            :key="index"
            :title="item"
          >
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            {{ item.substring(0, 50) }}{{ item.length >= 50 ? "..." : "" }}
            <br />
          </span> -->
          <span class="text-nowarp" v-if="isShowCompanyName(props.row.cusname)">
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            <b
              v-if="
                props.row.companyName !== null &&
                  props.row.companyName !== undefined
              "
            >
              {{ props.row.companyName.substring(0, 50)
              }}{{ props.row.companyName.length >= 50 ? "..." : "" }}
            </b>

            <br />
          </span>

          <span
            v-for="(item, index) in getComplainantCompany(props.row.cusname)"
            :key="item.timeStamp"
            class="text-nowarp"
          >
            <feather-icon
              v-if="item.type == '3'"
              icon="UserIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '8'"
              icon="UsersIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '476'"
              icon="BriefcaseIcon"
              class="mr-50"
            />
            <span v-else></span
            ><b>
              {{ item.text.substring(0, 50)
              }}{{ item.text.length >= 50 ? "..." : "" }}</b
            >
            <br />
          </span>

          <span
            v-for="(item, index) in props.row.complainantJsonList.filter(
              function(value) {
                return value.role === 3;
              }
            )"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UserIcon" class="mr-50" />{{ item.fName }}
            {{ item.lName }}
            <br />
          </span>

          <span
            v-for="(item, index) in props.row.complainantJsonList.filter(
              function(value) {
                return value.role === 8;
              }
            )"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UsersIcon" class="mr-50" />{{ item.fName }}
            {{ item.lName }}
            <br />
          </span>

          <span
            v-for="(item, index) in getComplainantUser(props.row.cusname)"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon
              v-if="item.type == '3'"
              icon="UserIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '8'"
              icon="UsersIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '476'"
              icon="BriefcaseIcon"
              class="mr-50"
            />
            <span v-else></span>{{ item.text.substring(0, 50)
            }}{{ item.text.length >= 50 ? "..." : "" }}
            <br />
          </span>
        </span>
        <!-- Column: Complain_Subject -->
        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.complaintDateStr }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.channelName }}
          </span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="btn-icon "
              @click="redirectClick(props.row.complaintId)"
              title="แนบไฟล์"
            >
              <feather-icon icon="PaperclipIcon" class="mr-50" />
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              @click="modalClick(props.row.complaintId)"
              v-b-modal.modal-attach-list
              variant="outline-warning"
              class="btn-icon ml-1"
            >
              <feather-icon icon="EyeIcon" class="mr-50" />
            </b-button>
            <!-- <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item>
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown> -->
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <AttachFileList :items="items" />
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "./code";
import AttachFileList from "../../modals/AttachFileList.vue";
import * as ViewStore from "@/store/api/screening/screening.js";
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    AttachFileList,
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    ViewStore,
    ComplaintAPI,
  },
  data() {
    return {
      SelectedComplaintGuid: "",
      items: [],
      pageLength: 10,
      totalRecords: 0,
      params: {},
      dir: false,
      codeBasic,
      columns: [
        {
          label: "เลขร้องทุกข์",
          field: "complaintCode",
        },
        {
          label: "ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ / ผู้มอบอำนาจ",
          field: "companyName",
        },
        {
          label:
            "วันที่ยื่นเรื่อง (จำนวนวันดำเนินการตั้งแต่ยื่นเรื่อง) / สถานะดำเนินการ / ช่องทางร้องทุกข์",
          field: "status",
        },
        {
          label: "Action",
          field: "action",
          tdClass: "text-center",
        },
      ],
      rows: [],

      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    // this.$http.get('/complaint/list')
    //   .then(res => { this.rows = res.data })
  },
  methods: {
    onSearchSubmit(params, page = { currentPage: 1 }) {
      console.log("onSearchSubmit", params);

      this.params = params;
      params.page = page.currentPage;
      params.perPage = this.pageLength;

      console.log("rows:", this.rows);

      var _this = this;

      _this.$emit("handleOverlay", true);

      ComplaintAPI.getComplaintForAttachment(params)
        .then(function(response) {
          // handle success
          console.log("then", response);
          _this.rows = response.data.data;
          try {
            _this.totalRecords = response.data.data[0].totalCount;
          } catch (ex) {
            console.log("get total records error", ex);
            _this.totalRecords = 0;
          }
          //console.log('result', _this.rows)
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });

      // ViewStore.getComplaintForDivision(params).then(function (response) {
      //   // handle success
      //   console.log('then', response);
      //   _this.rows = response.data.data
      //   console.log('result', _this.rows)
      // })
      // .catch(function (error) {
      //   // handle error
      //   console.log('error',error);
      // })
      // .then(function () {
      //   // always executed
      //   console.log('GET')
      // });
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params);
    },
    redirectClick(param) {
      this.$router.push({
        name: "servicecentercomplaintUpload",
        query: {
          parentComponent: "attachment",
          complaintGuid: param,
          //isGroupGuid: true,
        },
      });
    },
    modalClick(param) {
      var _self = this;
      ComplaintAPI.getComplaintById(param)
        .then(function(response) {
          // handle success
          try {
            _self.items = response.data.data.attachFiles;
          } catch (ex) {
            _self.items = [];
          }

          console.log("then", response.data.data.attachFiles);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
        });
    },
    isShowCompanyName(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let company = complainantList.find((value) => value.type === "476");

        //console.log('complainantList', complainantList, company)

        if (company !== null && company !== undefined) {
          //console.log('return false')
          return false;
        }
        //console.log('return true')
        return true;
      } catch (ex) {
        return true;
      }
    },
    getComplainantCompany(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let companies = complainantList.filter(function(value) {
          value.timeStamp = Date.now();
          return value.type === "476";
        });

        //console.log("companies", companies);

        return companies;
      } catch (ex) {
        return [];
      }
    },
    getComplainantUser(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let users = complainantList.filter(function(value) {
          return value.type !== "476";
        });

        return users;
      } catch (ex) {
        return [];
      }
    },
    getComplainantList(cusname) {
      try {
        let records = cusname.split(",");

        let results = [];

        records.forEach((value) => {
          try {
            //console.log("propValue", value);

            let propSplit = value.split(":");

            let propObj = {};

            if (propSplit[0] !== null && propSplit[0] !== undefined) {
              propObj.type = propSplit[0];
            }

            if (propSplit[1] !== null && propSplit[1] !== undefined) {
              propObj.text = propSplit[1];
            } else {
              propObj.text = "";
            }

            results.push(propObj);
          } catch (ex) {
            console.log("prop split ex", ex);
          }
        });

        return results;
      } catch (ex) {
        return [];
      }
    },
  },
};
</script>
